// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__xvcPw","logoContainer":"footer_logoContainer__VCLLy","logo":"footer_logo__0KLOb","footer-mobile":"footer_footer-mobile__0OG8m"};